import { Box, Typography } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

import type { CoretexTheme } from "../theme";
import SecondaryLabel from "./SecondaryLabel";

const useStyles = makeStyles((theme: CoretexTheme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.mono.superDark,
      padding: theme.spacing(0.5, 1),
      overflow: "hidden",
      borderRadius: "3px",
      boxShadow: theme.elevation.strong,
      border: `1px solid ${theme.palette.mono.secondaryDark}`,
      "&:hover": {
        backgroundColor: theme.palette.mono.primaryDark,
        border: "none",
      },
      cursor: "pointer",
    },
    label: {
      fontWeight: 800,
      color: theme.palette.mono.white,
      textTransform: "uppercase",
      fontSize: "10px",
      letterSpacing: "1px",
    },
    selected: {
      backgroundColor: theme.palette.mono.primaryDark,
      border: "none",
    },
    secondary: {
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(1, 2, 2, 2),
    },
  }),
);

export interface MarkerLabelProps {
  id: string;
  label?: string;
  records?: Record<string, string>;
  selected?: boolean;
  secondary?: boolean;
  template?: string;
  persistent?: boolean;
  onClick?: () => void;
  onMouseOver?: () => void;
  onMouseOut?: () => void;
}

const MarkerLabel = ({
  id,
  records,
  label,
  selected,
  secondary,
  template,
  persistent,
  onClick,
  onMouseOver,
  onMouseOut,
}: MarkerLabelProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Box
      className={clsx(
        selected && classes.selected,
        secondary && classes.secondary,
        secondary && !persistent && classes.selected,
        classes.root,
      )}
      key={`markerLabel-${id}`}
      onClick={onClick}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    >
      <Typography className={classes.label}>{label}</Typography>
      {records && secondary && <SecondaryLabel id={id} records={records} template={template} />}
    </Box>
  );
};

export default MarkerLabel;
